import { DEFAULT_NOTIFICATION_TIMEOUT_MS, MessageType } from '../constants/createSegment';
import { API_ERROR } from '../constants/editorConfig';
import { FAILED_CAMPAIGN_CREATION, SUCCESS_CAMPAIGN_CREATION } from '../constants/messages';
import { CREATE_CAMPAIGN_JOURNEY } from '../constants/urlConstants';
import { ResponseStatus } from '../enums/responseStatus';
import apiRequest from '../util/apiRequest';
import {
  ADD_NEW_CAMPAIGN,
  DELETE_JOURNEY_CAMPAIGN,
  RESET_JOURNEY_DETAILS,
  SUBMIT_MULTI_CAMPAIGN_FORM,
  UPDATE_FORM_VIEW,
  UPDATE_JOURNEY_CHANNEL,
  UPDATE_JOURNEY_CONTENT,
  UPDATE_JOURNEY_SCHEDULE,
  UPDATE_JOURNEY_SEGMENT,
  UPDATE_MULTI_CAMPAIGN_DETAILS,
  UPDATE_MULTI_CAMPAIGN_RESPONSE,
} from './journeyDetailsActionTypes';
import { SHOW_NOTIFICATON } from './notificationActionsType';

export const createMultiCampaign = (payload, sessionToken) => dispatch => {
  let status = '';
  let data = {};
  return apiRequest(CREATE_CAMPAIGN_JOURNEY, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
    .then(res => {
      if (res.status >= 400) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      data = res;
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.SUCCESS,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: SUCCESS_CAMPAIGN_CREATION,
        },
      });
    })
    .catch(() => {
      status = ResponseStatus.ERROR;
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.ERROR,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: FAILED_CAMPAIGN_CREATION,
        },
      });
    })
    .finally(() => {
      dispatch({
        type: UPDATE_MULTI_CAMPAIGN_RESPONSE,
        payload: {
          status,
          data,
        },
      });
    });
};

export const addNewCampaign = () => async dispatch => {
  await dispatch({
    type: ADD_NEW_CAMPAIGN,
    payload: null,
  });
};

export const deleteCampaignSection = campaignId => async dispatch => {
  await dispatch({
    type: DELETE_JOURNEY_CAMPAIGN,
    payload: campaignId,
  });
};

export const updateJourneyContent = (campaignId, data) => async dispatch => {
  await dispatch({
    type: UPDATE_JOURNEY_CONTENT,
    payload: {
      campaignId,
      data,
    },
  });
};

export const updateJourneySegment = (campaignId, data) => async dispatch => {
  await dispatch({
    type: UPDATE_JOURNEY_SEGMENT,
    payload: {
      campaignId,
      data,
    },
  });
};

export const updateJourneySchedule = (campaignId, data) => async dispatch => {
  await dispatch({
    type: UPDATE_JOURNEY_SCHEDULE,
    payload: {
      campaignId,
      data,
    },
  });
};

export const updateJourneyChannel = (campaignId, data) => async dispatch => {
  await dispatch({
    type: UPDATE_JOURNEY_CHANNEL,
    payload: {
      campaignId,
      data,
    },
  });
};

export const updateMultiCampaignDetail = data => async dispatch => {
  await dispatch({
    type: UPDATE_MULTI_CAMPAIGN_DETAILS,
    payload: data,
  });
};

export const submitMultiCampaignForm = () => async dispatch => {
  await dispatch({
    type: SUBMIT_MULTI_CAMPAIGN_FORM,
  });
};

export const resetJourneyDetails = () => async dispatch => {
  await dispatch({
    type: RESET_JOURNEY_DETAILS,
  });
};

export const setFormView = readonly => async dispatch => {
  await dispatch({
    type: UPDATE_FORM_VIEW,
    payload: readonly,
  });
};
